export function detalharMidia(errorOrEvent, stream) {
  return JSON.stringify({
    evento: errorOrEvent?.type || null,
    excecao: errorOrEvent?.name || null,
    mensagem: errorOrEvent?.message || null,
    restricao: errorOrEvent?.constraint || null,
    streamAtivo: stream?.active ?? null,
    tracks: stream ? stream.getTracks().map(track => ({
      tipo: track.kind,
      estado: track.readyState,
      habilitado: track.enabled,
      mudo: track.muted
    })) : []
  });
}
